import Index from "@/views/root/Index";
import Callback from '@/views/root/Callback'
import NotFound from '@/views/root/NotFound'
import InvoiceIndex from '@/views/fmwebapp/invoices/Index'
import  * as ProductInfo from '@/mixins/productInfo'

function isFMModule() {
    return ProductInfo.IsUrlFMModule;
}

export default [
    {
        name: 'index',
        path: '/',
        component: isFMModule() ? InvoiceIndex : Index,
        meta: {
            permissionName: null
        }
    },
    {
        name: 'callback',
        path: '/callback',
        component: Callback,
        meta: {
            requiresAuthentication: false
        }
    },
    {
        name: `notfound`,
        path: '/404',
        component: NotFound
    }
]